<template>
  <div>
    <div align="left">
      <br />
      <h5 class="h5 mb-4 text-primary">
        <b>Life in Paxel</b>
      </h5>
    </div>
    <b-card class="text-left">
      <b>Edit Story</b>
      <b-row class="mt-4">
        <b-col md="6">
          <b-form-group id="fieldset-1" label="Title (Bahasa)" label-for="input-1">
            <input
              v-model="items.title.id"
              v-validate="'required|min:5|max:30'"
              name="title_id"
              class="form-control"
              placeholder="Title In Bahasa"
            />
            <b-form-invalid-feedback id="input-title_id-feedback">{{ veeErrors.first('title_id') }}</b-form-invalid-feedback>
          </b-form-group>
        </b-col>
        <b-col md="6">
          <b-form-group id="fieldset-1" label="Title (English)" label-for="input-1">
            <input
              v-model="items.title.en"
              v-validate="'required|min:5|max:30'"
              name="title_en"
              class="form-control"
              placeholder="Title In English"
            />
            <b-form-invalid-feedback id="input-title_en-feedback">{{ veeErrors.first('title_en') }}</b-form-invalid-feedback>
          </b-form-group>
        </b-col>
      </b-row>
      <b-row>
        <b-col md="6">
          <b-form-group id="fieldset-1" label="Content (Bahasa)" label-for="input-1">
            <textarea
              id="textarea"
              v-model="items.content.id"
              placeholder="Description In Bahasa Indonesia"
              v-validate="'required|min:5|max:30'"
              name="content_id"
              class="form-control"
            ></textarea>
            <b-form-invalid-feedback
              id="input-content_id-feedback"
            >{{ veeErrors.first('content_id') }}</b-form-invalid-feedback>
          </b-form-group>
        </b-col>
        <b-col md="6">
          <b-form-group id="fieldset-1" label="Content (English)" label-for="input-1">
            <textarea
              id="textarea"
              v-model="items.content.en"
              placeholder="Description In English"
              v-validate="'required|min:5|max:30'"
              name="content_en"
              class="form-control"
            ></textarea>
            <b-form-invalid-feedback
              id="input-content_en-feedback"
            >{{ veeErrors.first('content_en') }}</b-form-invalid-feedback>
          </b-form-group>
        </b-col>
      </b-row>
      <b-row>
        <b-col md="6" class="pr-0">
          <b-form-group id="fieldset-1" label="Media" label-for="input-1">
            <b-form-radio-group
              v-model="items.media"
              :options="options"
              v-validate="'required'"
              name="radio-media"
            >
              <p
                class="text-danger"
                style="width:100%;margin-top:.25rem;font-size: 80%;"
              >{{ veeErrors.first('radio-media') }}</p>
            </b-form-radio-group>
          </b-form-group>
        </b-col>
      </b-row>
      <b-row class="mb-3" v-show="items.media == 'upload' || items.media == 'embeded'">
        <b-col md="6">
          <b-form-group
            id="fieldset-1"
            label="URL"
            v-show="items.media == 'embeded'"
            label-for="input-1"
          >
            <input
              placeholder="Link"
              v-model="items.url"
              v-validate="items.media == 'embeded' ? 'required|max:30' : 'max:30'"
              name="link"
              class="form-control"
            />
            <p
              class="text-danger"
              style="width:100%;margin-top:.25rem;font-size: 80%;"
            >{{ veeErrors.first('link') }}</p>
          </b-form-group>
          <b-form-group
            id="fieldset-1"
            label="Media File"
            label-for="input-1"
            v-show="items.media == 'upload'"
          >
            <b-card body-class="py-2 px-2">
              <card-body>
                <b-row>
                  <b-col class="text-primary mt-2">
                    <i class="fas fa-paperclip"></i>
                    &nbsp;
                    Photo
                    <sup
                      class="text-secondary pl-3 mr-5 pr-5"
                    >(2 Mb)</sup>
                  </b-col>
                  <b-col class="text-right" align="right">
                    <input
                      type="file"
                      ref="file"
                      v-validate="'image|dimensions:500,500|ext:jpg,png,gif,jpeg'"
                      name="image"
                      style="display: none"
                      v-on:change="onChangeFileUpload()"
                    />
                    <b-button
                      @click="$refs.file.click()"
                      v-show="!file && !items.image"
                      variant="primary"
                      class="ml-5"
                    >Select File</b-button>
                    <b-button
                      v-show="file || items.image"
                      variant="primary"
                      @click="modalImage = !modalImage"
                      class="mr-2"
                    >Preview</b-button>
                    <b-button
                      @click="$refs.file.click()"
                      v-show="file || items.image"
                      variant="outline-primary"
                      class
                    >Change File</b-button>
                  </b-col>
                </b-row>
              </card-body>
            </b-card>
          </b-form-group>
        </b-col>
      </b-row>
      <b-row>
        <b-col>
          <b-form-group id="fieldset-1" label="Status" label-for="input-1">
            <b-form-radio-group v-model="items.status" :options="options2" name="radio-status"></b-form-radio-group>
          </b-form-group>
        </b-col>
      </b-row>
      <b-row class="text-right">
        <b-col>
          <b-button variant="primary" :disabled="loading" @click="put()" size="lg" class="mr-3">Save</b-button>
          <router-link :to="{name: 'pxLifeInPaxel'}">
            <b-button size="lg" variant="outline-secondary">Cancel</b-button>
          </router-link>
        </b-col>
      </b-row>
    </b-card>
    <b-modal v-model="modalImage" title="Preview Image" size="xl">
      <img v-show="!file" v-if="items.image" width height="400px" :src="items.image" />
      <img v-show="file" v-if="urlImage" width height="400px" :src="urlImage" />
    </b-modal>
  </div>
</template>

<script>
import dataService from "../dataService";

export default {
  data() {
    return {
      text1: "",
      text2: "",
      items: [],
      selected1: null,
      selected2: null,
      file: null,
      modalImage: false,
      loading: false,
      options: [
        { text: "Upload", value: "upload" },
        { text: "Embed", value: "embeded" }
      ],
      options2: [
        { text: "Publish", value: "publish" },
        { text: "Archive", value: "archive" }
      ]
    };
  },
  beforeCreate() {
    // this.$store.dispatch("getDonatur");
    this.$store.dispatch(
      "lifeInPaxelModule/getLifeInPaxel",
      this.$route.params.id
    );
  },
  created() {
    this.$store.watch(
      state => state.lifeInPaxelModule.lifeinpaxel_id,
      (newValue, oldValue) => {
        this.items = newValue;
        // Do whatever makes sense now
        if (this.items.length === 0) {
          this.loading = true;
        } else {
          this.loading = false;
        }
      }
    );
  },
  methods: {
    put() {
      this.$validator.validateAll().then(result => {
        if (result) {
          const formData = new FormData();
          formData.append("image", this.items.image);
          formData.append("url", this.items.url);
          formData.append("media", this.items.media);
          formData.append("title_id", this.items.title.id);
          formData.append("title_en", this.items.title.en);
          formData.append("content_id", this.items.content.id);
          formData.append("content_en", this.items.content.en);
          formData.append("status", this.items.status);
          this.loading = true;
          this.$store
            .dispatch("lifeInPaxelModule/putLifeInPaxel", {
              id: this.$route.params.id,
              formData
            })
            .then(response => {
              this.loading = false;
              this.$router.push({ name: "pxLifeInPaxel" });
              this.$swal({
                type: "success",
                title: "Your work has been saved",
                showConfirmButton: false,
                timer: 1500
              });
              console.log(response);
            })
            .catch(error => {
              this.loading = false;
              this.serverError = error.response.data;
              console.log(error);
            });
        } else {
          this.$swal("ERROR!", this.veeErrors, "warning");
        }
      });
    },
    onChangeFileUpload() {
      this.file = this.$refs.file.files[0];
      this.InputImage = true;
      const input = this.$refs.file;
      const { files } = input;
      if (files && files[0]) {
        const reader = new FileReader();
        reader.onload = e => {
          const img = new Image();
          this.urlImage = e.target.result;
        };
        reader.readAsDataURL(files[0]);
        this.$emit("input", files[0]);
      }
    }
  }
};
</script>

<style>
</style>
